<template>
  <section>

    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Property Evaluation</p>
          <p class="title">Quest</p>
          <p class="is-size-7">For investors doing single and multi-family.</p>
          <p class="subtitle">$79/mo</p>
          <p>&nbsp;</p>
          <b-button
            class="button"
            type="is-info"
          >Get Quest</b-button>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Simple Accounting</p>
          <p class="title">BasilBooks</p>
          <p class="is-size-7">For investors to account for their investments.</p>
          <p class="subtitle">$19/mo</p>
          <p>&nbsp;</p>
          <b-button
            class="button"
            type="is-info"
          >Get BasilBooks</b-button>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Investment Management</p>
          <p class="title">Syndicate Starter</p>
          <p class="is-size-7">For Leads building their prospective investor list.</p>
          <p class="subtitle">$79/mo</p>
          <p>&nbsp;</p>
          <b-button
            class="button"
            type="is-info"
          >Get Syndicate Starter</b-button>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Investment Management</p>
          <p class="title">Syndicate Plus</p>
          <p class="is-size-7">For Leads working on their 1st and 2nd syndication.</p>
          <p class="subtitle">$279/mo</p>
          <p>&nbsp;</p>
          <b-button
            class="button"
            type="is-info"
          >Get Syndicate Plus</b-button>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Investment Management</p>
          <p class="title">Syndicate Pro</p>
          <p class="is-size-7">For Leads working on their 3rd or more syndications.</p>
          <p class="subtitle">$479/mo</p>
          <p>&nbsp;</p>
          <b-button
            class="button"
            type="is-info"
          >Get Syndicate Pro</b-button>
        </div>
      </div>
    </nav>

    <b-input
      type="email"
      value=""
      placeholder="Email on file with Lifestyles Unlimited"
    >
    </b-input>
  </section>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  email,
  numeric
} from "vuelidate/lib/validators";
import moment from "moment";
import Divider from "bulma-divider/dist/css/bulma-divider.min.css";

export default {
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    email: {
      email,
      required
    },
    password: {
      required,
      minLength: minLength(4)
    },
    firstNameOnCard: {
      required
    },
    lastNameOnCard: {
      required
    },
    ccNumber: {
      required,
      numeric
    },
    cvv: {
      required,
      numeric
    },
    expirationMonth: {
      required,
      numeric,
      minLength: minLength(2),
      maxLength: maxLength(2)
    },
    expirationYear: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4)
    }
  },

  data() {
    return {
      firstName: "A",
      lastName: "A",
      email: "a@a.com",
      password: "aaaa",
      firstNameOnCard: "BB",
      lastNameOnCard: "BB",
      ccNumber: "4111111111111111",
      cvv: "123",
      expirationMonth: "02",
      expirationYear: "2020",
      //   firstName: "",
      //   lastName: "",
      //   email: "",
      //   password: "",
      //   firstNameOnCard: "",
      //   lastNameOnCard: "",
      //   ccNumber: "",
      //   cvv: "",
      //   expirationMonth: "",
      //   expirationYear: "",
      trialEndDate: moment()
        .add(7, "days")
        .calendar(),
      agreed: false,
      trialPeriod: "Days7",
      checkbox: undefined
    };
  },

  components: { Divider },

  methods: {
    passwordCheck($v) {
      if (
        (!$v.password.required || !$v.password.minLength) &&
        $v.password.$error
      )
        return "true";
      else return "false";
    },

    async signup() {
      console.log(
        "signup()",
        this.firstName,
        this.lastName,
        this.email,
        this.password,
        this.firstNameOnCard,
        this.lastNameOnCard,
        this.ccNumber,
        this.cvv,
        this.expirationMonth,
        this.expirationYear,
        this.trialPeriod
      );
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showError("ERROR");
      } else {
        var email = this.email;
        var password = this.password;
        var firstName = this.firstName;
        var lastName = this.lastName;
        var firstNameOnCard = this.firstNameOnCard;
        var lastNameOnCard = this.lastNameOnCard;
        var ccNumber = this.ccNumber;
        var cvv = this.cvv;
        var expirationMonth = this.expirationMonth;
        var expirationYear = this.expirationYear;
        var trialPeriod = this.trialPeriod;
        await this.$store
          .dispatch("createSubscription", {
            email,
            password,
            firstName,
            lastName,
            firstNameOnCard,
            lastNameOnCard,
            ccNumber,
            cvv,
            expirationMonth,
            expirationYear,
            trialPeriod
          })
          .then(
            () => {
              this.showSuccess(
                "Congratulations, you are all set! Login with your email and password."
              );

              // Make sure we are not authenticated.
              this.$store.commit("CLEAR_SESSION");

              // Navigate to the web site for sign in.
              this.$router.push("properties");
            },
            () => {}
          );
      }
    }
  },

  mounted() {
    console.log("trial", this.$route.query.trial);
    this.$store.state.isLoginRequired = false;
    if (this.$route.query.trial == "Days14") {
      this.trialPeriod = "Days14";
      this.trialEndDate = moment()
        .add(14, "days")
        .calendar();
    } else this.trialPeriod = "";
  },

  beforeDestroy() {
    this.$store.state.isLoginRequired = true;
  }
};
</script>

<style>
@import "/bulma-divider/dist/css/bulma-divider.min.css";
</style>
